import { DependencyList, RefObject, UIEvent, useEffect } from 'react';

const useScroll = (ref: RefObject<any>, onScroll?: (event?: UIEvent) => void, onScrollEnd?: () => void, deps: DependencyList = []) => {
    let isScrolling = false;
    let interval: any;

    const __onScroll = () => {
        isScrolling = true;
        onScroll && onScroll();
        clearInterval(interval);

        interval = setInterval(() => {
            isScrolling = false;
            clearInterval(interval);
            onScrollEnd && onScrollEnd();
        }, 100);
    };

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        ref.current?.removeEventListener('scroll', __onScroll);
        ref.current.addEventListener('scroll', __onScroll);

        return () => {
            ref.current?.removeEventListener('scroll', __onScroll);
        };
    }, deps);
};

export default useScroll;
